module.exports = __webpack_public_path__ + "img/MT4.51684718.png";